// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__u++Fv","main":"Layout_main__LGxbI","mainExpanded":"Layout_mainExpanded__vH1nr","content":"Layout_content__Oyi3p"};